import { defineStore } from 'pinia'
import { ref } from 'vue'

import { eventBus } from '@/entities/webrtc'

import { Layouts } from '..'

export const callSessionsLayoutsStore = defineStore('call-sessions-layouts', () => {
  const layoutsByRoomPServed = ref(new Map<string, Layouts>())
  const manualLayoutsByRoomPServed = ref(new Set<string>())

  const markLayoutAsManual = (roomPServed: string) => {
    const next = new Set(manualLayoutsByRoomPServed.value)
    next.add(roomPServed)
    manualLayoutsByRoomPServed.value = next
  }

  const isLayoutManuallySet = (roomPServed: string) => {
    return manualLayoutsByRoomPServed.value.has(roomPServed)
  }

  const clearRoomLayout = (roomPServed: string) => {
    layoutsByRoomPServed.value.delete(roomPServed)

    const next = new Set(manualLayoutsByRoomPServed.value)
    next.delete(roomPServed)
    manualLayoutsByRoomPServed.value = next
  }

  eventBus.on('callEndedInRoom', (roomPServed: string) => {
    clearRoomLayout(roomPServed)
  })

  return {
    layoutsByRoomPServed,
    manualLayoutsByRoomPServed,
    markLayoutAsManual,
    isLayoutManuallySet,
    clearRoomLayout,
  }
})
